import React from 'react'
import AgoraSignallingComponent from 'src/components/AgoraSingallingComponent/AgoraSignallingComponent'
import { DISPATCH_EVENT_KEYS } from 'src/consumer/constants'
import { getAumhumScreenId } from 'src/consumer/services/localstorageServices'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'

void React

const AgoraSignallingComponentForAumhumScreens = () => {
  let deviceId = null
  const aumhumScreenId = getAumhumScreenId()
  if (aumhumScreenId) {
    deviceId = aumhumScreenId
  }
  const roles = getAllRolesInBoolean()

  const shouldInitialize = Boolean(deviceId) && (roles.isClinicAssistant || roles.isAumhumScreen || roles.isChamberScreen)
  if (!shouldInitialize) return <></>

  return (
    <AgoraSignallingComponent
      deviceId={deviceId}
      dispatchEventKey={DISPATCH_EVENT_KEYS.aumhumScreenSignalingEvent}
    />
  )
}

export default AgoraSignallingComponentForAumhumScreens
